import { AnyAction, Dispatch } from 'redux';
import { SeamlessConnection, SeamlessCoreStore } from '@seamless/store';
import { initializeStoreConnection } from '../store.util';

export type ContextBarState = {
  isVisible: boolean;
};

export const initialState: ContextBarState = {
  isVisible: true,
};

export type ContextBarDispatchers = {
  setVisibility: (payload: boolean) => void;
};

export const connectionName = 'EMH_CONTEXT_BAR';

export class ContextBarConnection extends SeamlessConnection<ContextBarDispatchers, ContextBarState> {
  private readonly SET_VISIBILITY = `${connectionName}.SET_VISIBILITY`;

  constructor() {
    super(connectionName);
  }

  get initialState(): ContextBarState {
    return initialState;
  }

  getReducer() {
    return (state: ContextBarState, action: AnyAction): ContextBarState => {
      switch (action.type) {
        case this.getActionType(this.SET_VISIBILITY):
          return {
            ...state,
            isVisible: action.payload,
          };
        default:
          return state;
      }
    };
  }

  getPublicDispatchers() {
    return {
      setVisibility: (payload: boolean) => (dispatch: Dispatch) => {
        dispatch(this.getAction(this.SET_VISIBILITY, payload));
      },
    };
  }
}

export let contextBarStore: SeamlessCoreStore;
export let contextBarDispatchers: ContextBarDispatchers;

export const initializeContextBarStore = async () => {
  contextBarStore = (await initializeStoreConnection<ContextBarState, ContextBarDispatchers>(
    ContextBarConnection,
  )) as SeamlessCoreStore;
  contextBarDispatchers = {
    ...(await contextBarStore.getConnectionDispatchers<ContextBarDispatchers>(connectionName)),
    ...contextBarDispatchers,
  };
};
